import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-3f3811cb"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "contract-link-header-title" };
const _hoisted_2 = { class: "status-content" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_FriedIcon = _resolveComponent("FriedIcon");
    const _component_FriedStatusBadge = _resolveComponent("FriedStatusBadge");
    return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(['contract-link-header', _ctx.blockWidthClass])
    }, [
        _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_FriedIcon, { icon: "contracts" }),
            _renderSlot(_ctx.$slots, "title", {}, undefined, true)
        ]),
        _createElementVNode("div", _hoisted_2, [
            _renderSlot(_ctx.$slots, "button", {}, undefined, true),
            (_ctx.showStatus)
                ? (_openBlock(), _createBlock(_component_FriedStatusBadge, {
                    key: 0,
                    text: _ctx.statusBadgeContent.text,
                    "status-type": _ctx.statusBadgeContent.statusType,
                    border: _ctx.statusBadgeContent.border
                }, null, 8, ["text", "status-type", "border"]))
                : _createCommentVNode("", true)
        ])
    ], 2));
}
